
import { Product } from "domain/entities/shop/product/product";
import { onMounted, defineComponent, PropType } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    hasEnoughDecoins: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
    isProductOutOfStock: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
    checkEnough: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
    checkProductIsActive: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
    addToBag: {
      type: Function as PropType<(product: Product) => void>,
      required: true,
    },
    removeFromBag: {
      type: Function as PropType<(product: Product) => void>,
      required: true,
    },
    bagIncludes: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
    setButtonText: {
      type: Function as PropType<(product: Product) => string>,
      required: true,
    },
    addToFavorites: {
      type: Function as PropType<(product: Product) => void>,
    },
    isFavorite: {
      type: Function as PropType<(product: Product) => boolean>,
      required: true,
    },
    removeFromFavoriteList: {
      type: Function as PropType<(product: Product) => void>,
    },
  },
  setup() {
    const store = useStore();

    const loadFavoriteProducts = async () => {
      await store.dispatch("shop_module/loadFavoriteProducts", {
        page: 1,
        limit: 6,
      });
    };

    onMounted(() => {
      loadFavoriteProducts();
    });

    /** Function responsible for adding the product to favorites.
     * @param product parameter that receives an object of type Product as a variable. */
    const addToFavorites = async (product: Product) => {
      try {
        await store.dispatch("shop_module/addToFavorite", product.id);
        await loadFavoriteProducts();
      } catch (e) {
        console.error(e);
      }
    };

    /** Function responsible for removing the product from favorites.
     * @param product parameter that receives an object of type Product as a variable. */
    const removeFromFavoriteList = async (product: Product) => {
      try {
        await store.dispatch(
          "shop_module/removeProductFromFavorites",
          product.id
        );
        await loadFavoriteProducts();
      } catch (e) {
        console.error(e);
      }
    };

    return {
      addToFavorites,
      removeFromFavoriteList,
    };
  },
});
